
import Vue from 'vue';
import { IItem, IState } from './store/state';
import { search } from './store/actions';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

// Interfaces for component typechecking!
interface AppData {

}

interface AppMethods {
	loadMore(): void;
  focusFirstNewElement(index: number): void;
  updateItemLink(items:NodeListOf<HTMLElement>): void;
}

interface AppComputed {
  items: IItem[];
  loading: boolean;
  total: number;
  numberToShow: number
}

interface AppProps {

}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	computed: {
		items() {
      return this.$store.getters.items;
    },

    total() {
      return this.$store.getters.total;
    },
    
    loading() {
      return (this.$store.state as IState).loading;
    },

    numberToShow() {
      return this.$store.getters.numberToShow;
    }
	},
	methods: {
    loadMore() {
      let index = this.items.length;
			console.log(this.items.length)
      this.$store.commit({
        type: 'setNumberToShow',
        payload: Number(this.numberToShow) + Number(this.$store.state.initialNumberToShow)
      })
      this.$store.dispatch(search(''));
      this.focusFirstNewElement(index);
    },

    focusFirstNewElement(index: number){
      let links: NodeListOf<HTMLElement> = document.querySelectorAll('.hiq-blog-list__items-item-link');
      let items: NodeListOf<HTMLElement> = document.querySelectorAll('.hiq-blog-list__items-item');
      if(links[index]){
        links[index].focus();
      } else {
        setTimeout(() => { this.focusFirstNewElement(index) }, 100);
      }
      if(items) {
        this.updateItemLink(items);
      }
    },

    updateItemLink(items: NodeListOf<HTMLElement>) {
      items.forEach((item: any) => {
        const link:HTMLElement = item.querySelector('a');
        if (link) {
          item.style.cursor = 'pointer';
          const url = link.getAttribute('href') || '/';
          item.addEventListener('click', function () {
            window.location.href = url;
          });
        }
      })
    }
	},
	updated() {
    let items: NodeListOf<HTMLElement> = document.querySelectorAll('.hiq-blog-list__items-item');
    if(items) {
      this.updateItemLink(items);
    }
  },
	components: {
		PulseLoader
	}
})
